<template>
  <section class="newsletter border">
    <div class="container">
      <div class="form-container">
        <div class="container-info align-left">
          <div class="info-area" v-html="data.area" />
          <div class="info-title" v-html="data.title" />
          <img :src="data.image_mobile" class="hide-desktop" />

          <form @submit.prevent="sendForm()">
            <div class="input">
              <input
                type="text"
                id="name"
                placeholder="Nombre y Apellido*"
                name="name"
                v-model="name"
                :class="[nameError ? 'error' : '']"
              />
            </div>
            <div class="input">
              <input
                type="email"
                id="email"
                placeholder="Email*"
                name="email"
                v-model="email"
                :class="[emailError ? 'error' : '']"
              />
            </div>
            <div class="input">
              <input type="number" id="phone" placeholder="Teléfono" name="phone" v-model="phone" />
            </div>
            <div class="input">
              <input
                type="text"
                id="city"
                placeholder="Localidad / Provincia"
                name="city"
                v-model="city"
              />
            </div>
            <div class="input">
              <textarea name="message" id="message" placeholder="Mensaje" v-model="message" />
            </div>
            <div class="radio-container" :class="[typeError ? 'error' : '']">
              <label class="radio" :class="[type === 'Instalador' ? 'active' : '']">
                <span>
                  <input
                    v-model="type"
                    name="radio-group"
                    id="instalador"
                    type="radio"
                    value="Instalador"
                  />
                </span>
                SOY UN INSTALADOR*
              </label>
              <label class="radio" :class="[type === 'Distribuidor' ? 'active' : '']">
                <span>
                  <input
                    v-model="type"
                    name="radio-group"
                    id="distribuidor"
                    type="radio"
                    value="Distribuidor"
                  />
                </span>
                SOY UN DISTRIBUIDOR*
              </label>
            </div>
            <div class="radio-container" :class="[newsletterError ? 'error' : '']">
              <label class="radio" for="newsletter" :class="[newsletter === true ? 'active' : '']">
                <span>
                  <input id="newsletter" type="checkbox" v-model="newsletter" />
                </span>
                Acepto recibir información de la industria eléctrica*.
              </label>
            </div>

            <button class="button" v-html="data.button" />
            <div class="response sending" v-if="isSending">Enviando contacto...</div>
            <div class="response success" v-if="showResponse">¡Contacto enviado correctamente!</div>
            <small v-html="data.required" />
          </form>
        </div>
      </div>
      <img :src="data.image" class="hide-mobile" />
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  props: ["data"],
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      city: "",
      message: "",
      type: "",
      newsletter: false,
      showError: false,
      nameError: false,
      emailError: false,
      typeError: false,
      newsletterError: false,
      showResponse: false,
      isSending: false,
    };
  },
  methods: {
    sendForm() {
      let data = new FormData();
      data.append("name", this.name);
      data.append("email", this.email);
      data.append("phone", this.phone);
      data.append("city", this.city);
      data.append("location", this.location);
      data.append("message", this.message);
      data.append("type", this.type);
      data.append("newsletter", this.newsletter);

      if (
        this.name === "" ||
        this.email === "" ||
        this.type === "" ||
        this.newsletter === false
      ) {
        if (this.name === "") {
          this.nameError = true;
        }
        if (this.email === "") {
          this.emailError = true;
        }
        if (this.type === "") {
          this.typeError = true;
        }
        if (this.newsletter !== true) {
          this.newsletterError = true;
        }
      } else {
        this.showError = false;
        this.nameError = false;
        this.emailError = false;
        this.typeError = false;
        this.newsletterError = false;
        this.isSending = true;

        const postData =
          process.env.NODE_ENV === "production"
            ? "/dms+/data/sub.php"
            : "http://localhost/dms-php/sub.php";

        try {
          axios
            .post(postData, data, {
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.showResponse = true;
                this.isSending = false;

                setTimeout(() => {
                  this.showResponse = false;
                }, 10000);
              }
            });
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
};
</script>

<style lang="scss" src="./Newsletter.scss" />